import { connect } from 'react-redux';

const mapStateToProps = ({ TrackerData: { allTrackerEvents } }) => ({ allTrackerEvents });

export default (WrappedComponent) => connect(mapStateToProps, null)(WrappedComponent);
